export default __webpack_public_path__ + "static/media/111.d9abdbb2.png";